<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import api from '@/api/goods'

export default {
  name: 'App',
  async created () {
    if (getToken()) {
      const _data = await api.publicConfig()
      localStorage.setItem('config', JSON.stringify(_data))
    }
  }
}
</script>

<style>
.flex__center {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex__between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
/* el-drawer 滚动 */
.el-drawer__body {
	overflow: hidden;
	overflow-y: auto;
}
.tox-tinymce-aux {
  z-index: 3000!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue